<template>
  <button type="button" class="iconButton" @click="clickButton">
    <img v-if="icon" :src="getIcon(icon)" alt="" />
    <span v-if="!icon" class="dummy image"></span>
    <span class="iconButton_label">{{ label }}</span>
  </button>
</template>

<script lang="ts">
import { SetupContext } from 'vue'
import { useRouter } from 'vue-router'

export default {
  name: 'IconButton',

  props: {
    label: {
      type: String,
      default: 'ボタン'
    },
    path: {
      type: String,
      default: '/'
    },
    icon: String
  },

  setup(props: any, context: SetupContext) {
    const router = useRouter()

    const clickButton = () => {
      if (props.path !== '/') {
        router.push({ path: props.path })
      } else {
        context.emit('click-btn')
      }
    }

    const getIcon = (icon: string) => {
      return require(`@/assets/images/icon/${icon}.svg`)
    }

    return {
      clickButton,
      getIcon
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.iconButton {
  display: block;
  width: 100%;
  text-align: center;
  font-weight: 600;
  font-size: 1rem;
  color: var.$color-main-text;
  line-height: 1;
}

.iconButton_label {
  display: block;
  margin-top: 5px;
}

.dummy {
  display: inline-block;
  width: 20px;
  height: 20px;
  background-color: var.$color-main;
  border-radius: 100%;
}
</style>
